import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  heading: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
  },
}))

const PageHeading = ({ heading, subheading }) => {
  const classes = useStyles()
  return (
    <Box mb={4}>
      <Typography variant="h1" className={classes.heading}>{heading}</Typography>
      <Typography variant="body1">{subheading}</Typography>
    </Box>
  )
}

export default PageHeading
